<script>
    import { createEventDispatcher } from 'svelte';
    import { t } from 'svelte-i18n';
    import { changePassword } from '../controllers/userController.js';

    export let show = false;
    export let userId = '';
    
    const dispatch = createEventDispatcher();
    
    let newPassword = '';
    let confirmPassword = '';
    let oldPassword = '';
    let error = '';
    
    async function handleSubmit() {
        error = '';
        
        if (!oldPassword || !newPassword || !confirmPassword) {
            error = 'Por favor complete todos los campos';
            return;
        }
        
        if (newPassword !== confirmPassword) {
            error = 'Las contraseñas no coinciden';
            return;
        }
        
        if (newPassword.length < 8) {
            error = 'La contraseña debe tener al menos 8 caracteres';
            return;
        }
        
        const success = await changePassword(userId, newPassword, oldPassword);
        if (success) {
            dispatch('close');
            newPassword = '';
            confirmPassword = '';
            oldPassword = '';
        }
    }
</script>

{#if show}
    <div class="modal-backdrop">
        <div class="modal-content">
            <h2>Cambiar Contraseña</h2>
            
            {#if error}
                <div class="error-message">{error}</div>
            {/if}
            
            <form on:submit|preventDefault={handleSubmit}>
                <div class="form-group">
                    <label for="oldPassword">Contraseña Actual</label>
                    <input
                        type="password"
                        id="oldPassword"
                        bind:value={oldPassword}
                        placeholder={$t('auth.password')}
                    />
                </div>
                
                <div class="form-group">
                    <label for="newPassword">Nueva Contraseña</label>
                    <input
                        type="password"
                        id="newPassword"
                        bind:value={newPassword}
                        placeholder={$t('auth.password')}
                    />
                </div>
                
                <div class="form-group">
                    <label for="confirmPassword">Confirmar Contraseña</label>
                    <input
                        type="password"
                        id="confirmPassword"
                        bind:value={confirmPassword}
                        placeholder={$t('auth.password')}
                    />
                </div>
                
                <div class="button-group">
                    <button type="submit" class="btn-primary">Cambiar Contraseña</button>
                    <button type="button" class="btn-secondary" on:click={() => dispatch('close')}>
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </div>
{/if}

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
    
    .modal-content {
        background-color: white;
        padding: 2rem;
        border-radius: 8px;
        width: 100%;
        max-width: 400px;
    }
    
    h2 {
        margin-top: 0;
        margin-bottom: 1.5rem;
        color: #333;
    }
    
    .form-group {
        margin-bottom: 1rem;
    }
    
    label {
        display: block;
        margin-bottom: 0.5rem;
        color: #666;
    }
    
    input {
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 1rem;
    }
    
    .button-group {
        display: flex;
        gap: 1rem;
        margin-top: 1.5rem;
    }
    
    button {
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 1rem;
    }
    
    .btn-primary {
        background-color: #4CAF50;
        color: white;
    }
    
    .btn-secondary {
        background-color: #f44336;
        color: white;
    }
    
    .error-message {
        color: #f44336;
        margin-bottom: 1rem;
        padding: 0.5rem;
        background-color: #ffebee;
        border-radius: 4px;
    }
</style> 